module.exports = __webpack_public_path__ + "static/img/operainBudgetg.7091ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operainBudgetg.png
// module id = iWZa
// module chunks = 1